export namespace FpcsActions{
    export class SetAllFpcs {
        static readonly type = '[FpcFamilies] SetAllFpcs';
        constructor() {}
    }
}